export const cardApi = {
    list: {
        method: 'post',
        api: 'admin/cards/list'
    },
    get: {
        method: 'post',
        api: 'admin/cards/get'
    },
    add: {
        method: 'post',
        api: 'admin/cards/add'
    },
    edit: {
        method: 'post',
        api: 'admin/cards/edit'
    },
    del: {
        method: 'post',
        api: 'admin/cards/del'
    },
    templetlist: {
        method: 'post',
        api: 'admin/cards/templetlist'
    },
    templetadd: {
        method: 'post',
        api: 'admin/cards/templetadd'
    },
    templetedit: {
        method: 'post',
        api: 'admin/cards/templetedit'
    },
    templetdel: {
        method: 'post',
        api: 'admin/cards/templetdel'
    },
  }